/** Persistencia del "Ahora no" del prompt de instalación (spec: 30 días). */

export const INSTALL_PROMPT_DISMISSED_KEY = "t123-install-prompt-dismissed-at";
export const INSTALL_PROMPT_SNOOZE_MS = 30 * 24 * 60 * 60 * 1000;

export interface KeyValueStorage {
  getItem(key: string): string | null;
  setItem(key: string, value: string): void;
}

export function shouldShowInstallPrompt(storage: KeyValueStorage, now: number): boolean {
  const raw = storage.getItem(INSTALL_PROMPT_DISMISSED_KEY);
  if (!raw) return true;
  const dismissedAt = Number(raw);
  if (!Number.isFinite(dismissedAt)) return true;
  return now - dismissedAt >= INSTALL_PROMPT_SNOOZE_MS;
}

export function markInstallPromptDismissed(storage: KeyValueStorage, now: number): void {
  storage.setItem(INSTALL_PROMPT_DISMISSED_KEY, String(now));
}
